import useBatchIntegrationNotification from "../../hooks/useBatchIntegrationNotification";

const BatchIntegrationWebsocket = () => {
  useBatchIntegrationNotification();
  return <></>;
};

export default BatchIntegrationWebsocket;
